export const ORG_ONE_PRICES = {
  basic: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 0,
    },
  },
  standard: {
    month: {
      GBP: 5,
      USD: 6,
    },
    year: {
      GBP: 36,
      USD: 48,
    },
  },
  premium: {
    month: {
      GBP: 7,
      USD: 9,
    },
    year: {
      GBP: 60,
      USD: 84,
    },
  },
};

export const ORG_FIVE_PRICES = {
  basic: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 0,
    },
  },
  standard: {
    month: {
      GBP: 0,
      USD: 5,
    },
    year: {
      GBP: 0,
      USD: 20,
    },
  },
  premium: {
    month: {
      GBP: 0,
      USD: 8,
    },
    year: {
      GBP: 0,
      USD: 30,
    },
  },
};

export const ORG_SEVEN_PRICES = {
  basic: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 0,
    },
  },
  standard: {
    month: {
      GBP: 5,
      USD: 6,
    },
    year: {
      GBP: 36,
      USD: 48,
    },
  },
  premium: {
    month: {
      GBP: 7,
      USD: 9,
    },
    year: {
      GBP: 60,
      USD: 84,
    },
  },
};

export const ORG_FOURTEEN_PRICES = {
  basic: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 0,
    },
  },
  standard: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 20,
    },
  },
  premium: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 40,
    },
  },
};



// WEBPACK FOOTER //
// ./library/app/components/Signup/Prices.js